import styled from 'styled-components';
import {StyledTextProps} from './typings';
import typography from '@/theme/typography';
import pxToRem from '@/theme/helpers/pxToRem';
import StyledActionText from '@/atoms/ActionText/styles';

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  > *:not(:last-child) {
    margin-right: ${pxToRem(5)};
  }
`;

export const StyledText = styled.p<StyledTextProps>`
  ${(props) => (props.$strong ? typography.Subtitle1 : typography.Body2)}
  ${(props) => props.$bottomMargin && `margin-bottom: ${pxToRem(7)}`}

  & + ${StyledActionText} {
    margin-top: ${pxToRem(10)};
    display: block;
  }
`;
